up.compiler('.update-selection', (element) => {
  const target = document.querySelector(element.getAttribute('data-target'));
  const value = element.getAttribute('data-value');
  element.addEventListener('change', (event) => {
    var selectedValue = event.target.value;
    if(value) {
      selectedValue = value;
    }
    if (target) {
      target.innerText = selectedValue;
      target.classList.remove('bg-warning-subtle');
      target.classList.remove('border-warning');
      target.classList.add('bg-success-subtle');
      target.classList.add('border-success');
    }
  });
});

up.compiler('#material-master-data .btn.select-material', (element, data) => {
  element.addEventListener('click', (event) => {
    const target = document.querySelector(data['target']);
    if (target) {
      target.innerText = data['value'];
    }
    const proxyElem = document.getElementById('selected-material-proxy').querySelector('input')
    proxyElem.value = data['id'];
    proxyElem.dispatchEvent(new Event('change', { bubbles: true }))
  });
});

up.compiler('form#new_warehousemanagement_stock_item', (element) => {
  element.addEventListener('change', (event) => {
    const materialInput = element.querySelector('input[name="warehousemanagement_stock_item[material_id]"]');
    const storageSpotRadio = element.querySelector('input[name="warehousemanagement_stock_item[storage_spot]"]:checked');

    if(materialInput && materialInput.value && storageSpotRadio && storageSpotRadio.value) {
      element.querySelector('#fixed-bottom-left').classList.remove('inactive');
    }
  });
});

window.updateStorageSpotSelection = function(scannedText) {
  const radioButton = document.querySelector(`[data-qr='${scannedText}']`);
  const bucket_input = document.getElementById('warehousemanagement_stock_item_bucket_id');
  if (!radioButton && bucket_input && getStorageArray(scannedText)[0] !== bucket_input.value) {
    up.layer.open({content: invalidScanOperationHtml('Gescannter Lagerplatz gehört nicht zum ausgewählten Lager', 'updateStorageSpotSelection(value)', 'warning'), dismissable: 'key outside'});
    return;
  }
  if (!radioButton) {
    up.layer.open({content: invalidScanOperationHtml('Unbekannte Lagerposition gescannt', 'updateStorageSpotSelection(value)'), dismissable: 'key outside'});
    return;
  }
  if (radioButton && (radioButton.getAttribute('disabled') !== undefined && radioButton.getAttribute('disabled') !== null)) {
    up.layer.open({content: invalidScanOperationHtml('Lagerposition bereits belegt!', 'updateStorageSpotSelection(value)', 'warning'), dismissable: 'key outside'});
    return;
  }

  radioButton.checked = true;
  radioButton.dispatchEvent(new Event('change', { bubbles: true }));
}


window.invalidScanOperationHtml = function(errorHTML, onAcceptedCallback, color='danger') {
  const alert = document.createElement('div');
  alert.className = `alert alert-${color} text-center`;
  alert.innerHTML = errorHTML;
  const buttonWrapper = document.createElement('div');
  buttonWrapper.className = 'd-flex mt-5 justify-content-between';
  const dismissButton = document.createElement('button');
  dismissButton.className = 'btn btn-primary';
  dismissButton.setAttribute('up-dismiss', 'true');
  dismissButton.textContent = 'Abbrechen';
  buttonWrapper.appendChild(dismissButton);
  buttonWrapper.appendChild(scanModalLink(onAcceptedCallback));
  return alert.outerHTML + buttonWrapper.outerHTML;
}

window.scanModalLink = function(onAcceptedCallback) {
  const link = document.createElement('a');
  link.setAttribute('up-layer', 'swap modal');
  link.setAttribute('up-size', 'full');
  link.setAttribute('up-dismissable', 'key outside');
  link.setAttribute('up-accept-event', 'scan:success');
  link.setAttribute('up-on-accepted', onAcceptedCallback);
  link.setAttribute('class', 'btn btn-xl btn-outline-primary');
  link.setAttribute('tabindex', '0');
  link.setAttribute('role', 'link');
  link.setAttribute('up-clickable', '');
  link.setAttribute('up-content',
    `<div id="scan-wrapper" scanaction="accept">
      <div id="barcode-reader" class="mt-4"><div class="loading-spinner mt-5 text-center d-flex flex-column align-items-center"><svg class="scan-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 371.643 371.643" style="enable-background:new 0 0 371.643 371.643" xml:space="preserve" fill="currentColor"><path fill="currentColor" d="M105.084 38.271h163.768v20H105.084z"></path><path fill="currentColor" d="M311.596 190.189c-7.441-9.347-18.403-16.206-32.743-20.522V30c0-16.542-13.458-30-30-30H125.084c-16.542 0-30 13.458-30 30v120.143h-8.296c-16.542 0-30 13.458-30 30v1.333a29.804 29.804 0 0 0 4.603 15.939c-7.34 5.474-12.103 14.221-12.103 24.061v1.333c0 9.84 4.763 18.587 12.103 24.062a29.81 29.81 0 0 0-4.603 15.938v1.333c0 16.542 13.458 30 30 30h8.324c.427 11.631 7.503 21.587 17.534 26.177.931 10.503 4.084 30.187 14.768 45.537a9.988 9.988 0 0 0 8.216 4.288 9.958 9.958 0 0 0 5.704-1.793c4.533-3.155 5.65-9.388 2.495-13.921-6.798-9.767-9.602-22.608-10.76-31.4h82.685c.272.414.545.818.815 1.21 3.142 4.541 9.372 5.679 13.913 2.534 4.542-3.142 5.677-9.371 2.535-13.913-11.919-17.229-8.787-35.884 9.581-57.012 3.067-2.652 12.307-11.732 11.217-24.033-.828-9.343-7.109-17.194-18.669-23.337a9.857 9.857 0 0 0-1.061-.486c-.466-.182-11.403-4.579-9.741-15.706 1.007-6.737 14.768-8.273 23.766-7.666 23.156 1.569 39.698 7.803 47.836 18.026 5.752 7.225 7.607 16.623 5.673 28.733-.413 2.585-.824 5.241-1.245 7.959-5.756 37.194-12.919 83.483-49.87 114.661-4.221 3.561-4.756 9.87-1.194 14.092a9.98 9.98 0 0 0 7.648 3.551 9.955 9.955 0 0 0 6.444-2.358c42.672-36.005 50.802-88.533 56.737-126.888.415-2.684.821-5.309 1.229-7.863 2.834-17.721-.455-32.641-9.772-44.345zm-232.308 42.62c-5.514 0-10-4.486-10-10v-1.333c0-5.514 4.486-10 10-10h15v21.333h-15zm-2.5-52.666c0-5.514 4.486-10 10-10h7.5v21.333h-7.5c-5.514 0-10-4.486-10-10v-1.333zm17.5 93.999h-7.5c-5.514 0-10-4.486-10-10v-1.333c0-5.514 4.486-10 10-10h7.5v21.333zm30.796 28.887c-5.514 0-10-4.486-10-10v-8.271h91.457c-.851 6.668-.437 12.787.731 18.271h-82.188zm79.482-113.698c-3.124 20.906 12.427 33.184 21.625 37.04 5.441 2.968 7.551 5.647 7.701 7.188.21 2.15-2.553 5.684-4.477 7.251-.482.378-.929.8-1.335 1.261-6.987 7.936-11.982 15.52-15.432 22.688h-97.564V30c0-5.514 4.486-10 10-10h123.769c5.514 0 10 4.486 10 10v135.579c-3.032-.381-6.15-.694-9.389-.914-25.159-1.694-42.37 7.748-44.898 24.666z"></path><path fill="currentColor" d="M179.129 83.167h-24.06a5 5 0 0 0-5 5v24.061a5 5 0 0 0 5 5h24.06a5 5 0 0 0 5-5V88.167a5 5 0 0 0-5-5zM172.629 142.86h-12.56V130.8a5 5 0 1 0-10 0v17.061a5 5 0 0 0 5 5h17.56a5 5 0 1 0 0-10.001zM216.568 83.167h-24.06a5 5 0 0 0-5 5v24.061a5 5 0 0 0 5 5h24.06a5 5 0 0 0 5-5V88.167a5 5 0 0 0-5-5zm-5 24.061h-14.06V93.167h14.06v14.061zM211.669 125.936H197.41a5 5 0 0 0-5 5v14.257a5 5 0 0 0 5 5h14.259a5 5 0 0 0 5-5v-14.257a5 5 0 0 0-5-5z"></path></svg><div class="spinner-border text-primary mt-5" role="status"><span class="sr-only">Lade Kamera...</span></div></div></div>
      <div class="d-flex mt-5 justify-content-center">
        <button class="btn btn-primary" up-dismiss="true">Abbrechen</button>
      </div>
    </div>`
  );

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('class', 'svg-inline--fa fa-qrcode icon-qrcode me-2');
  svg.setAttribute('aria-label', 'qrcode');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  svg.setAttribute('data-prefix', 'fas');
  svg.setAttribute('data-icon', 'qrcode');
  svg.setAttribute('role', 'img');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('viewBox', '0 0 448 512');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('fill', 'currentColor');
  path.setAttribute(
    'd',
    'M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z'
  );
  svg.appendChild(path);

  const span = document.createElement('span');
  span.textContent = 'erneut Scannen';

  link.appendChild(svg);
  link.appendChild(span);
  return link;
}

up.compiler('.update-result', (element) => {
  const rows = element.querySelectorAll('tr')
  rows.forEach((row) => {
    row.addEventListener('click', (event) => {
      rows.forEach((otherRow) => {otherRow.classList.remove('table-primary')})
      row.classList.add('table-primary')
      const url = new URL(window.location.href)
      url.searchParams.set('selected_stock_item', row.getAttribute('target-id'))
      up.reload('#result', {url: url.toString(), layer: 'root', 'abortable': false})
    })
  })
});
